const MeetingType = {
    QUICK: 'quick',
    SCHEDULE: 'schedule',
    TRAINING: 'training',
    CREATE_STEP: 'createStep',
    BEFORE_MIGRATION: 'beforeMigration',
    STATE_INITIALIZED: 'stateInitialized',
    SESSION_ONLY: 'sessionOnly',
    TEMPLATE: 'template'
};

const MeetingAccessType = {
    PUBLIC: 'public',
    PRIVATE: 'private',
    PROTECTED: 'protected'
};

const MeetingAccessTypeDisplay = {
    PUBLIC: 'Anyone with the link',
    PRIVATE: 'Project Members',
    PROTECTED: 'iQ3Connect Users'
};

module.exports = {
    MeetingType,
    MeetingAccessType,
    MeetingAccessTypeDisplay
};
